import { StatusTagDisplay } from "commonComponents/utilities/Status/StatusTagDisplay";

export enum SpecificationStatus {
    Draft = 0,
    Published = 1,
}

interface ISpecificationStatusBadgeProps {
    status: SpecificationStatus;
}

export const SpecificationStatusBadge = ({ status }: ISpecificationStatusBadgeProps) => {
    let statusLabel: string;
    switch (status) {
        case SpecificationStatus.Draft:
            statusLabel = "Draft";
            break;
        case SpecificationStatus.Published:
            statusLabel = "Published";
            break;
        default:
            statusLabel = "";
    }

    const statusVariant = status === SpecificationStatus.Published ? "success" : "";

    return <StatusTagDisplay statusType={statusVariant} statusText={statusLabel} />;
};
